import { Link } from "wouter";
import type { PublicBranchItem } from "@workspace/api-client-react";
import { BranchActions } from "./BranchActions";
import { OpenNowBadge } from "./OpenNowBadge";

export function BranchListItem({ branch, brandHandle }: { branch: PublicBranchItem; brandHandle: string }) {
  const place = [branch.address, branch.city].filter(Boolean).join(", ");
  return (
    <li className="flex flex-col gap-3 rounded-xl border border-border bg-card p-4">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          {branch.slug ? (
            <Link href={`/${brandHandle}/${branch.slug}`} className="inline-flex min-h-11 items-center font-semibold text-foreground hover:underline break-words">
              {branch.name}
            </Link>
          ) : (
            <span className="font-semibold break-words">{branch.name}</span>
          )}
          {place && <p className="text-sm text-muted-foreground break-words">{place}</p>}
        </div>
        {branch.distanceKm != null && (
          <span className="shrink-0 text-sm text-muted-foreground">{branch.distanceKm.toFixed(1)} km</span>
        )}
      </div>
      <OpenNowBadge openNow={branch.openNow} className="self-start" />
      <BranchActions branch={branch} brandHandle={brandHandle} />
    </li>
  );
}
